import PropTypes from 'prop-types';
import * as React from 'react';
import { useState } from 'react';
import { UserNavigation } from './components/UserNavigation';
import { useAuth } from 'lib/auth';
import { Menu, MessageCircle } from 'react-feather';
import { Sidebar } from './components/Sidebar';
import StatusBadge from './components/StatusBadge';
import Organisms from 'assets/organisms.svg';
import { Link, useNavigate } from 'react-router-dom';
import { MessageCount } from 'features/messaging';
import { Notifications } from './components/Notifications';

export const MainLayout = ({ children }) => {
  const { user } = useAuth();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const navigate = useNavigate();

  return (
    <div className="h-screen flex overflow-hidden bg-[#fcfcfc]">
      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Mobile Sidebar Overlay */}
      {mobileSidebarOpen && (
        <div className="fixed inset-0 flex z-40 md:hidden">
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-gray-600 bg-opacity-75"
            onClick={() => setMobileSidebarOpen(false)}
            aria-hidden="true"
          ></div>
          {/* Sidebar panel */}
          <div className="relative flex-1 flex flex-col max-w-xs w-full">
            <Sidebar isMobile onClose={() => setMobileSidebarOpen(false)} />
          </div>
          {/* Dummy element to force sidebar to shrink to fit close icon */}
          <div className="flex-shrink-0 w-14" aria-hidden="true"></div>
        </div>
      )}

      <div className="flex  mx-4 rounded-3xl my-4 flex-col w-0 flex-1 overflow-hidden">
        <div className="relative px-4 md:px-24 z-10 flex items-center flex-shrink-0 py-5">
          <div className="flex-1 px-4 flex justify-end items-center">
            {/* Mobile menu button */}
            <button className="md:hidden" onClick={() => setMobileSidebarOpen(true)}>
              <Menu className="h-6 text-white" />
            </button>
            <div className="ml-4 flex items-center md:ml-6">
              <Notifications onClick={() => navigate('/app/notifications')} />
              <MessageCount />
              <UserNavigation />
            </div>
          </div>
        </div>
        <main className="flex-1 relative overflow-y-auto focus:outline-none flex flex-col">
          <div className="flex-grow">{children}</div>

          {/* footer */}
          <footer className="mt-10 text-xs text-gray-400 text-center pt-4 space-y-1 mb-4">
            <div>© {currentYear} NorthUp Limited. All rights reserved.</div>
            <div>
              This platform complies with industry standards for data protection, accessibility, and
              information security. By using this service, you agree to our{' '}
              <a href="/terms" className="underline hover:text-white">
                Terms of Service
              </a>{' '}
              and{' '}
              <a href="/privacy" className="underline hover:text-white">
                Privacy Policy
              </a>
              .
            </div>
            <div>
              For questions or legal inquiries, contact{' '}
              <a href="mailto:compliance@northup.go.ug" className="underline hover:text-white">
                compliance@northup.go.ug
              </a>
              .
            </div>
          </footer>
        </main>
      </div>
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
